export const config = {
  namespaced: true,
  state: {
    botApiUrl: '',
    registerHasGeofence: false
  },
  mutations: {
    initialiseConfig(state) {
      console.log('Initialise config...')
      state.botApiUrl = localStorage.getItem('botApiUrl') || '';
    },
    botApiUrl(state, set) {
      state.botApiUrl = set
      if (set !== null) {
        localStorage.setItem('botApiUrl', set)
      } else {
        localStorage.removeItem('botApiUrl')
      }
    },
    registerHasGeofence(state, set) {
      state.registerHasGeofence = set
    }
  },
  actions: {
    apiUrlSet({ commit }, set) {
      commit('botApiUrl', set)
    },
    apiUrlRemove({ commit }) {
      commit('botApiUrl', null)
    },
    registerHasGeofenceSet({ commit }, set) {
      commit('registerHasGeofence', set)
    }
  },
  getters: {
    botApiUrl: state => state.botApiUrl,
    registerHasGeofence: state => state.registerHasGeofence
  }
}